import React, { Component } from 'react';
import cx from 'classnames';

import Modal from 'react-modal';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setPopUp } from 'actions/environment';
import { ROOT_URL } from 'constants/Config';
import SpinnerImage from 'components/common/SpinnerImage';
import apartments from 'constants/apartments';
import noFloor from 'assets/images/no-floor.png';
import zoomIcon from 'assets/images/icons/icon-zoom.svg';
import iconClose from 'assets/images/icons/cross.svg';
import { formatNumber } from 'utils';
import interiors from 'constants/interiors';
import popupStyles from 'components/Building/Chess/RightMenu/About/About.scss';
import { ChessGalleryPopupWithRouter } from './Gallery/Gallery';
import { compileQuery } from 'utils';

import s from '../styles';
import { withTranslation } from 'react-i18next';
import { isReserved as isReservedFunc } from '../../../helper';
import { ViewType } from './ViewType';

const digits = (number) => (number ? formatNumber(number) : '...');

@withRouter
@connect(null, { setPopUp })
class FlatsListItem extends Component {
  state = { showPopup: false }
  renderVectorOverlay({ all = false } = {}) {
    const { row, data, sectionCells } = this.props;
    if (data.pointers) {
      const [width, height] = data.pointers.split(':');
      return (
        <div className={s.Plan}>
          <div className="lol">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height={height}
              width={width}
              viewBox={`0 0 ${width} ${height}`}
            >
              <g>
                {
              (all
                ? sectionCells[row].cells
                : [data]
              ).filter(
                cell => cell && cell.pointers
              ).map(
                (cell) => {
                  const coordinates = cell.pointers.split(':')[2];
                  const cs = coordinates.split(',');
                  const path = cs.reduce(
                    (path, c, i) => path.concat(i % 2 === 1 ? `${c} L ` : `${c} `), 'M '
                  ).replace(/L $/, 'Z');
                  return (
                  [
                    <path
                      className={cx(s.Flat, { [s.SelectedFlat]: cell.id === data.id })}
                      d={path}
                      key={cell.id}
                      onMouseEnter={() => { this.setState({ hoverCellId: cell.id }); }}
                      onMouseLeave={() => {
                        if (this.state.hoverCellId === cell.id) {
                          this.setState({ hoverCellId: null });
                        }
                      }}
                    />
                  ]
                  );
                }
              )
            }
              </g>
            </svg>
          </div>
        </div>
      );
    }
  }

  state = {}

  handleShowPlanClick = (e) => {
    e.stopPropagation();
    this.setState({
      showModal: 'FLOOR_PLAN'
    });
  }

  handleCloseClick = () => {
    this.setState({
      showModal: false
    });
  }

  setPopUp = () => {
    const { setPopUp, data, building, showInfo, t } = this.props;
    const costFormatted = formatNumber(data.priceAll);
    const priceFormatted = formatNumber(data.priceM);

    const isReserved = isReservedFunc(data.status);

    setPopUp((
      <div className={popupStyles.PopUpOuter}>
        <div className={popupStyles.PopUpInner}>
          <div className={popupStyles.TopInfo}>
            <span>
              {`${showInfo == 1 ? `${building.title} / ` : ''}${t('components.flatsList.flatListItem.number', { number: data.row })} / №${data.number}`}
            </span>
          </div>
          <div className={popupStyles.BottomInfo}>
            <div className={popupStyles.LeftInfo}>
              <SpinnerImage
                className={popupStyles.ImageInfo} imageSrc={`${ROOT_URL}/image/polygon?id=${data.poligon_id}&preset=800`} imageAlt="Room"
                spinner={<div className={popupStyles.LoaderInfo} />}
              />
            </div>
            <div className={popupStyles.RightInfo}>
              {data.hidden
                ? (isReserved
                  ? (
                    <div className={popupStyles.SoldInfo}>
                      <span dangerouslySetInnerHTML={{ __html: t('components.flatsList.flatListItem.reserved') }} />
                    </div>
                  )
                  : (
                    <div className={popupStyles.SoldInfo}>
                      <span>
                        {t('components.flatsList.flatListItem.sold')}
                      </span>
                    </div>
                  ))
                : ((isReserved && (costFormatted == 0))
                  ? (
                    <div className={popupStyles.SoldInfo}>
                      <span dangerouslySetInnerHTML={{ __html: t('components.flatsList.flatListItem.reserved') }} />
                    </div>
                  )
                  : (
                    <div>
                      <div className={popupStyles.PopupFlatInfo}>
                        <span className={popupStyles.FlatNum}>№{data.number}</span>
                        <div className={popupStyles.PopupTagsWrap}>
                          {((data.view_action === '1') && !(data.status === 'soldStatus'))
                            ? (
                              <span className={popupStyles.TagPromo}>
                                {t('components.flatsList.flatListItem.promo')}
                              </span>
                            )
                            : (null)}
                          {isReserved
                            ? (
                              <span className={popupStyles.TagReserve}>
                                <i>{t('components.flatsList.flatListItem.reserve')}</i>
                              </span>
                            )
                            : (null)}
                        </div>
                      </div>
                      <div className={popupStyles.PriceInfo}>
                        {`${costFormatted} ₽`}
                        <div className={popupStyles.SmallInfo}>
                          <span>
                            {t('components.flatsList.flatListItem.priceFormatted', { priceFormatted })}
                          </span>
                        </div>
                      </div>

                      <div className={cx(popupStyles.FlatOptions, popupStyles.PopupFlatOptions)}>
                        {data.area
                          ? (
                            <div className={popupStyles.FlatOption}>
                              <span>
                                {t('components.flatsList.flatListItem.area', { area: data.area })}
                              </span>
                            </div>
                          )
                          : ''}
                        {data.apartmentsName
                          ? (
                            <div className={popupStyles.FlatOption}>
                              {data.apartmentsName}
                            </div>
                          )
                          : ''}
                        {(data.interior == 'predChistInt')
                          ? (
                            <div className={popupStyles.FlatOption}>
                              <span>
                                {t('components.flatsList.flatListItem.predChistInt')}
                              </span>
                            </div>
                          )
                          : (data.interiorName
                            ? (
                              <div className={popupStyles.FlatOption}>
                                <span>{data.interiorName}</span>
                              </div>
                            )
                            : '')}
                      </div>
                    </div>
                  ))
    }
            </div>
          </div>
        </div>
      </div>
    ), {
      className: popupStyles.popupFlat,
      backgroundClassName: popupStyles.popupFlatBg,
      contentClassName: popupStyles.popupFlatContent,
      closeIcon: 'gallery'
    });
  }

  handleClose = () => {
    this.setState({
      showPopup: false
    });
  }

  setFloorPopUp = (e) => {
    e.stopPropagation();
    this.setState({ showPopup: true });
  }

  handleCellClick = (id, selected) => {
    const cell = selected.join('.');
    this.transitionTo({ cell });
  }

  handleFilters = (update = {}) => {
    const { buildingForGallery: { selected } } = this.props;
    const { section: selectedSectionPath, prevSection } = update;
    if (selectedSectionPath) {
      const selectedSectionKey = selectedSectionPath.join('.');
      const selectedCellPath = selected[selectedSectionKey];
      const selectedCellKey = selectedCellPath ? selectedCellPath.join('.') : null;
      this.prevSection = prevSection;
      this.transitionTo({ section: selectedSectionKey, cell: selectedCellKey });
    }
  }

  transitionTo(queryParams) {
    const { history } = this.props;
    const path = this.getPath(queryParams);
    history.push(path);
    return path;
  }

  getPath(queryParams) {
    const { match, client, print, location } = this.props;
    const { params } = match;
    const query = compileQuery(queryParams, location.search);
    const search = query ? `?${query}` : '';
    if (client) {
      return `/view/${params.referal}/building/${params.id}${search}`;
    }
    if (print) {
      return `/print/${params.id}${search}`;
    }
    return `/building/${params.id}/chess${search}`;
  }


  renderFloorPopup = () => {
    const { setPopUp, data, planId, flatId, buildingForGallery, building, pointers } = this.props;
    const {
      // data: building,
      chessList,
      filters,
      cells,
      selected,
      isTable,
      isExtended,
      listSort,
      tableScroll
    } = buildingForGallery;

    const pavilionsFlat = this.props.buildingForGallery.pavilions;

    const { section: selectedSectionPath } = filters;
    let sectionCells = null;
    let chess = null;
    let sectionId;
    let selectedSectionKey;
    let selectedCellPath;
    let selectedCell;
    let scrollKey;
    let defaultScroll = [0, 0];
    let sortKey;

    if (building && pavilionsFlat) {
      selectedSectionKey = selectedSectionPath.join('.');
      selectedSectionKey = (cells[selectedSectionKey] || !this.prevSection) ? selectedSectionKey : this.prevSection.join('.');
      sectionCells = cells[selectedSectionKey];

      if (sectionCells) {
        const [pavilionIndex, sectionIndex] = cells[selectedSectionPath.join('.')] ? selectedSectionPath : this.prevSection;
        sectionId = pavilionsFlat[pavilionIndex].sections[sectionIndex].id;
        const chessRaw = chessList[sectionId];
        const cols = chessRaw.cols.reduce((prev, cur) => {
          let { colspan } = cur;
          colspan = Number(colspan) || 1;
          const cols = Array(colspan).fill(null);
          cols[0] = cur;
          return prev.concat(cols);
        }, []);
        chess = { ...chessRaw, cols };
        selectedCellPath = selected[selectedSectionKey];
        const [row, column] = selectedCellPath;
        selectedCell = selectedCellPath ? sectionCells[row].cells[column] : null;
        scrollKey = ([pavilionIndex, sectionIndex, isTable, isTable ? isExtended : null]).filter((value) => (value != null)).join('.');
        sortKey = listSort.join('.');
        defaultScroll = tableScroll[scrollKey] || [0, 0];
        this.dataFlats = this.dataFlats !== undefined ? this.dataFlats : building.count_flats;
      }
    }
    const rows = (chess && chess.rows) || [];
    // console.log(data, building, sectionCells, selectedCell);
    // console.log(sectionCells, data);
    // console.log(sectionCells.find(cell => cell.cells.find(o => {
    //   return o.data.headId == data.headId
    // })));
    // console.log(selectedCell, this.props);
    return (
      <Modal
        isOpen={this.state.showPopup}
        onRequestClose={this.handleClose}
        contentLabel="Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: 10
          },
          content: {
            padding: 0,
            border: 'none',
            width: '950px',
            height: '650px',
            top: '50%',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 0)'
          }
        }}
      >
        <ChessGalleryPopupWithRouter
          {...this.props}
          rows={rows} // этажи
          row={rows.length - (+data.row)} // текущий этаж
          sectionCells={sectionCells} // выбор точек для отрисовки overlay
          data={selectedCell} // информация о текщуем этаже для отрисовки свг
          filters={filters}
          pavilionsFlat={pavilionsFlat} // нужен для фильтров
          cells={chess.cells} // мб кваритры
          onClose={this.handleClose}
          handleCellClick={this.handleCellClick}
          handleFilters={this.handleFilters}
          planId={planId}
          flatId={flatId}
          floor={data.row}
          roomData={data}
          pointers={pointers}
          isClientView
        />
      </Modal>
    );
  }

  render() {
    const {
      flatId, planId, pavilionName, sectionName, pavilionId, pavilions, t,
      data: { number, row, area, priceAll, priceM, cnt_apart, interior, status, poligon_id, view_action }
    } = this.props;

    const { construction_ending, year_built, construction_finished } = pavilions[pavilionId][0];

    return (
      <div
        className={cx(s.FlatsListItem, { [s.Active]: this.props.active })}
        onClick={() => this.props.handleFlatClick(flatId)}
      >
        <div className={s.FlatsListItemContent}>
          <div className={s.Left}>
            {
              poligon_id ?
                <div className={s.FlatPlan}>
                  <img src={`${ROOT_URL}/image/polygon?id=${poligon_id}&preset=100`} alt="" className={s.FlatPlanImage} />
                </div> : null
            }
            <div className={cx(s.FlatTitle, { [s.WithoutPLan]: !poligon_id })}>
              <p>
                {t('components.flatsList.flatListItem.area', { area })} · {apartments[cnt_apart]}
                {view_action === '1' && <span className={cx(s.TagPromo, s.MobileHide)}>{t('components.flatsList.flatListItem.promo')}</span>}
                {isReservedFunc(status) && <span className={cx(s.TagReserve, s.MobileHide)}>{t('components.flatsList.flatListItem.reserve')}</span>}
              </p>
              <p>
                <ViewType viewType={this.props.data.view_type} />
              </p>
              <p className={cx(s.FlatHousing, { [s.Done]: construction_finished })}>
                {t('components.flatsList.flatListItem.housing', { pavilionName, sectionName })}
              </p>

              <div className={cx(s.PriceMobile, s.OnlyMobile)}>{digits(priceAll)} ₽</div>
            </div>
          </div>
          <div className={s.Floor}>
            {t('components.flatsList.flatListItem.number', { number: row })}
          </div>
          <div className={s.Price}>{digits(priceAll)} ₽</div>
          <div className={cx(s.Right, s.OnlyMobile)}>
            {view_action === '1' && <span className={s.TagPromo}>{t('components.flatsList.flatListItem.promo')}</span>}
            {isReservedFunc(status) && <span className={s.TagReserve}>{t('components.flatsList.flatListItem.reserve')}</span>}
            <span></span>
            <div className={s.RightFloor}>
              {t('components.flatsList.flatListItem.number', { number: row })}
            </div>
          </div>
        </div>

        {
          this.props.active &&
          <div className={s.FlatsListItemHidden}>
            {
              poligon_id ?
                <div className={s.FlatPlanBig} onClick={this.setPopUp}>
                  <div className={s.FlatPlanHover}>
                    <img alt="zoom" src={zoomIcon} />
                  </div>
                  <img
                    className={s.FlatPlanImage}
                    src={`${ROOT_URL}/image/polygon?id=${poligon_id}&preset=400`}
                    alt=""
                  />
                </div> : null
            }

            <div className={s.FlatInfo}>
              <div className={s.FlatInfoItem}>
                <span>
                  {t('components.flatsList.flatListItem.flatNumber')}
                </span>
                <span>{number}</span>
              </div>
              <div className={s.FlatInfoItem}>
                <span>
                  {t('components.flatsList.flatListItem.price')}
                </span>
                <span>{digits(priceM)} ₽</span>
              </div>
              <div className={s.FlatInfoItem}>
                <span>
                  {t('components.flatsList.flatListItem.inner')}
                </span>
                <span>{interiors[interior]}</span>
              </div>
              <div className={cx(s.FlatStatus, s.ShowMd, { [s.Done]: construction_finished })}>
                {
                  construction_finished ?
                    t('components.flatsList.flatListItem.finished') :
                  `${construction_ending} / ${year_built}`
                }
              </div>
            </div>
            <div className={cx(s.FlatStatus, s.HiddenMd, { [s.Done]: construction_finished })}>
              {
                construction_finished ?
                  t('components.flatsList.flatListItem.finished') :
                `${construction_ending} / ${year_built}`
              }
            </div>
          </div>
        }
        {this.state.showPopup && this.renderFloorPopup()}

        <Modal
          isOpen={!!this.state.showModal}
          onRequestClose={this.handleCloseClick}
          contentLabel="Modal"
          className={s.ModalContent}
          style={{
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 7
            },
            content: {
              padding: '30px',
              background: '#fff',
              border: 'none',
              top: '6rem',
              right: '15rem',
              bottom: '6rem',
              left: '15rem'
            }
          }}
        >
          <div className={s.ModalClose} onClick={this.handleCloseClick}>
            <img src={iconClose} alt="" />
          </div>
          <SpinnerImage
            key={flatId}
            className={cx(s.ImageInner, { [s.ImagePrint]: print })}
            imageClassName={s.SpinnerImage}
            imageSrc={
              this.state.showModal === 'FLAT_PLAN' ?
              `${ROOT_URL}/image/polygon?id=${poligon_id}&preset=900` :
              `${ROOT_URL}/image/plan?id=${planId}&preset=900`
            }
            imageAlt="Floor preview"
            handleImageLoad={this.handleImageLoad}
            handleImageError={this.props.handleImageError}
            spinner={<div className={s.Loader} />}
            placeholder={(
              <div className={s.PlaceholderOuter}>
                <img className={s.PlaceholderImage} src={noFloor} alt="Not found" />
                <div className={s.PlaceholderText}>
                  {t('components.flatsList.flatListItem.emptyPlan')}
                </div>
              </div>
            )}
          >

            <div
              className={cx(s.Zoom)}
              onClick={this.setPopUp}
            >
              { this.renderVectorOverlay() }
            </div>

          </SpinnerImage>
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(FlatsListItem);



// WEBPACK FOOTER //
// ./src/components/FlatsList/FlatsListItem/FlatsListItem.js